var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * PauseFilled component
 */
export class BlocksIconPauseFilled extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         *
         * Append to the class name to pass classes (such as utility classes) into the internals
         */
        this.styleModifier = '';
    }
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span class="${componentClassName}" role="presentation">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.62458 1.1001C2.23601 1.1001 1.11035 2.22575 1.11035 3.61433V20.3759C1.11035 21.7644 2.23601 22.8901 3.62458 22.8901H7.81497C9.20354 22.8901 10.3292 21.7644 10.3292 20.3759V3.61433C10.3292 2.22575 9.20354 1.1001 7.81497 1.1001H3.62458ZM16.1957 1.1001C14.8072 1.1001 13.6815 2.22575 13.6815 3.61433V20.3759C13.6815 21.7644 14.8072 22.8901 16.1957 22.8901H20.3861C21.7746 22.8901 22.9004 21.7644 22.9004 20.3759V3.61433C22.9004 2.22575 21.7746 1.1001 20.3861 1.1001H16.1957Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property()
], BlocksIconPauseFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconPauseFilled.prototype, "iconTitle", void 0);
__decorate([
    property()
], BlocksIconPauseFilled.prototype, "size", void 0);
__decorate([
    property()
], BlocksIconPauseFilled.prototype, "styleModifier", void 0);
if (customElements.get('cat-icon-pause-filled') === undefined) {
    customElements.define('cat-icon-pause-filled', BlocksIconPauseFilled);
}
